import { render } from "./UserLevels.vue?vue&type=template&id=29d98457&scoped=true"
import script from "./UserLevels.vue?vue&type=script&lang=js"
export * from "./UserLevels.vue?vue&type=script&lang=js"

import "./UserLevels.vue?vue&type=style&index=0&id=29d98457&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29d98457"]])

export default __exports__